import * as React from 'react'

const Loading = (props: any) => (
  <svg {...props} viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z'
      transform='translate(1 1)'
      stroke='#37C47E'
      strokeWidth='2'
      strokeLinecap='round'
      strokeDasharray='42.41 42.41'
    />
  </svg>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/icons/membership/Loading.tsx